import { ReactComponent as IconDownload } from '@/assets/svgs/download-transaction-icon.svg';
import Button from "@/components/Button/index";
import CheckboxButton from '@/components/CheckboxButton';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import RadioButton from '@/components/RadioButton';
import { ToastContext } from "@/context/toast/index";
import { useNavigate } from '@/lib/router-dom/index';
import api from "@/services/api/messages.js";
import rem from "@/utils/rem";
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from "react";
import { convertBase64IntoFile } from '@/utils/download';
import downloadJS from "downloadjs";

const DEFAULT_STRUCTURE_DOWNLOAD_TYPE = "only_attachment";

export default function DownloadAllDataModal({
    visible, close, dataElementId, messageStoreId, all, isPackage, isFolder,
    defaultTotalFiles = 0,
    downloadName,
    downloadId,
    isVeridapt,
    packageActivity,
    defaultAttachmentType = "",
    defaultStructuredDataType = "",
    defaultStructuredDataCheckbox = false,
    defaultAttachmentsCheckbox = false,
    defaultContainsTTFile = false,
    defaultFileSize = "",
    isMultiPayload = false
}) {

    const maxDownloadSize = 150;
    const [fileSize, setFileSize] = useState(defaultFileSize);
    const [totalFiles, setTotalFiles] = useState(defaultTotalFiles)
    const [loading, setLoading] = useState(false);
    const { addToastMessage } = useContext(ToastContext);
    const { goTo } = useNavigate();

    const [structuredDataCheckbox, setStructuredDataCheckbox] = useState(defaultStructuredDataCheckbox)
    const [attachmentsCheckbox, setAttachmentsCheckbox] = useState(defaultAttachmentsCheckbox)
    const [structuredDataType, setStructuredDataType] = useState(defaultStructuredDataType)
    const [attachmentType, setAttachmentType] = useState(defaultAttachmentType)
    const [containTTFile, setContainTTFile] = useState(defaultContainsTTFile)

    useEffect(() => {
        if (!visible) {
            return
        }

        if (!structuredDataCheckbox && !attachmentType) {
            return findFileSize(true)
        }

        findFileSize()
    }, [structuredDataCheckbox, attachmentType])

    async function findFileSize(allFiles = false) {
        const payload = {
            ids: all ? downloadId : messageStoreId
        }

        setLoading(true);

        const body = {
            includePayload: (attachmentType === "allAttachment" || attachmentType === "tradetrust") ? structuredDataCheckbox : true,
            includeAttachments: attachmentType === "allAttachment" || attachmentType === "tradetrust",
            onlyTradeTrust: attachmentType === "tradetrust",
        }

        const requestOptions = allFiles ? {} : { params: body };
        const [err, response] = await api.checkDownloadAllFileSize(packageActivity, payload, requestOptions);

        setLoading(false);

        if (err) {
            return addToastMessage(
                err?.error?.message || "Unable to retrieve Config",
                "error"
            );
        }

        setFileSize(isNaN(response.totalFileSize) ? "0" : response.totalFileSize);
        setTotalFiles(response.totalFiles);
        setContainTTFile(response.isContainTTFile);
    }

    async function downloadFile() {
        let tempStructuredDataType = structuredDataType;
        const downloadingIDs = all ? downloadId : messageStoreId;
        setLoading(true);

        const body = {
            includePayload: structuredDataCheckbox,

            /* Setting default value for not including attachment */
            includeAttachments: false,

            /* Setting default value for tradeTrust filter */
            onlyTradeTrust: false,
        }

        if (attachmentsCheckbox) {
            if (attachmentType == "allAttachment") {
                body["includeAttachments"] = true
            }
            else if (attachmentType == "tradetrust") {

                /* For onlyTradeTrust needs both values needs to be true */
                body["includeAttachments"] = true
                body["onlyTradeTrust"] = true
            }
        }

        /**
         * The following condition appears when there's no selection of
         * DE structure payload download and only attachment download.
         * At that situation, we're marking download type from default value
         * to match URL pattern.
         */
        if (!tempStructuredDataType || tempStructuredDataType.length === 0) {
            tempStructuredDataType = DEFAULT_STRUCTURE_DOWNLOAD_TYPE;
        }

        const [error, result] = await api.downloadAllFiles(
            packageActivity,
            tempStructuredDataType,
            {
                ids: downloadingIDs,
            },
            {
                params: body,
            }
        );
        setLoading(false);

        if (error) {
            return addToastMessage(
                error?.message || "Unable to download file",
                "error"
            );
        }

        try {
            // download structured data only
            if (
                (downloadingIDs.length === 1 || isMultiPayload)
                && !body["includeAttachments"]
                && ["json", "csv"].includes(tempStructuredDataType)
                && (packageActivity === "data_element" || packageActivity === "payload")
            ) {
                const link = document.createElement("a");
                if (tempStructuredDataType === "json") {
                    const path = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(result, null, 2))}`
                    console.log("path", path)
                    link.href = path;
                    link.download = `${dataElementId + ".json"}`;
                    link.click();
                    close()
                    return;
                } else if (tempStructuredDataType === "csv") {
                    const path = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(result)}`
                    link.href = path;
                    link.download = `${dataElementId + ".csv"}`;
                    link.click();
                    close()
                    return;
                }
            }

            let downloadingFileName = downloadName;

            /* Handling downloadName only for single DE */
            //downlaod attachment/TT only
            if (
                (packageActivity === "data_element" || packageActivity === "payload")
                && (downloadingIDs.length === 1 || isMultiPayload)
                && !body["includePayload"]
                && (body["includeAttachments"] || body["onlyTradeTrust"])
            ) {
                downloadingFileName = `${dataElementId}.zip`;
            }

            /* Generating the file from base64 */
            const file = convertBase64IntoFile(
                result, "application/zip",
                downloadingFileName,
            );

            /* Downloading the file */
            downloadJS(file, downloadingFileName);

            // Closing the download popup
            close()
        } catch (error) {
            console.log({ error })
            return addToastMessage(
                "Unable to download file",
                "error"
            );
        }
    }

    function resetAllFields() {
        setStructuredDataCheckbox(false)
        setAttachmentsCheckbox(false)
        setStructuredDataType("")
        setAttachmentType("")
        setFileSize("")
    }

    useEffect(() => {
        if (visible) {
            findFileSize(true);
        }
        resetAllFields();
    }, [visible]);

    const renderLoadingBody = () => {
        return (
            <div className="download-transaction__rows">
                <div className="download-transaction__calculating__file__size">
                    Calculating download file size...
                </div>
            </div>
        )
    }
    const renderBody = () => {
        if (!fileSize) {
            return renderLoadingBody();
        }

        if (fileSize < maxDownloadSize || !isFolder) {
            return (
                <div className="download-transaction__rows">
                    <div className="download-transaction__row">
                        You are about to export Transaction ({fileSize} MB)
                    </div>
                    <div className="download-transaction__row">
                        <div className="download-transaction__row__left">
                            Download options:
                        </div>
                        <div className="download-transaction__row__right">

                            <div className="download-transaction_checkbox">
                                <CheckboxButton
                                    name={`Structured data`}
                                    check={structuredDataCheckbox}
                                    onChange={() => {
                                        setStructuredDataCheckbox(!structuredDataCheckbox)
                                        setStructuredDataType("")
                                    }}
                                    value={structuredDataCheckbox}
                                    disabled={Number.parseFloat(fileSize) <= 0}
                                />
                            </div>
                            <div className="download-transaction__row__right__radio">
                                <RadioButton
                                    name={'JSON'}
                                    check={structuredDataType === 'json' && structuredDataCheckbox}
                                    value={'json'}
                                    submit={(e) => setStructuredDataType(e.target.value)}
                                    disabled={!structuredDataCheckbox}
                                />
                            </div>
                            <div className="download-transaction__row__right__radio">
                                <RadioButton
                                    name={'CSV'}
                                    check={structuredDataType === 'csv' && structuredDataCheckbox}
                                    value={'csv'}
                                    submit={(e) => setStructuredDataType(e.target.value)}
                                    disabled={!structuredDataCheckbox}
                                />
                            </div>
                            <div className="download-transaction_checkbox-attachments">
                                <CheckboxButton
                                    name={`Attachments`}
                                    check={attachmentsCheckbox}
                                    onChange={() => {
                                        setAttachmentsCheckbox(!attachmentsCheckbox)
                                        setAttachmentType("")
                                    }}
                                    value={attachmentsCheckbox}
                                    disabled={fileSize > maxDownloadSize || totalFiles === 0}
                                />
                            </div>
                            <div className="download-transaction__row__right__radio">
                                <RadioButton
                                    value={'allAttachment'}
                                    name={'All attachments'}
                                    check={attachmentType == 'allAttachment' && attachmentsCheckbox}
                                    submit={(e) => setAttachmentType(e.target.value)}
                                    disabled={!attachmentsCheckbox}
                                />
                            </div>
                            <div className="download-transaction__row__right__radio">
                                <RadioButton
                                    value={'tradetrust'}
                                    name={'TradeTrust file only'}
                                    check={attachmentType == 'tradetrust' && attachmentsCheckbox}
                                    submit={(e) => setAttachmentType(e.target.value)}
                                    disabled={!attachmentsCheckbox || !containTTFile}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="download-transaction__calculating__file__size">
                <div>Download exceeded max size limit (150 MB).</div>
                <div>Please select the packages you wish to download.</div>
            </div>
        )
    }

    return (
        <Modal visible={visible} variant='medium' close={close}>
            <CardConfigure  >
                <CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<span className='download-transaction-modal__icon'><IconDownload /></span>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										{isFolder ? "Download Folder Data" : "Download Transaction"}
									</div>
								</div>
							</div>
						</div>
                    </CardConfigure.Header.Title>
                </CardConfigure.Header>
                <CardConfigure.Body>
                    <CardConfigure.Body.Col>
                        {renderBody()}
                    </CardConfigure.Body.Col>
                </CardConfigure.Body>
                <CardConfigure.Footer>
                    <CardConfigure.Footer.Right>
                        {(fileSize < maxDownloadSize || !isFolder) ?
                            <div>
                                <Button
                                    text="Cancel"
                                    submit={() => close()}
                                    ghost
                                />
                                <span style={{ width: rem(10), display: 'inline-block' }}></span>
                                <Button
                                    text="Confirm"
                                    loading={loading}
                                    data-testid="download-btn"
                                    disabled={(!structuredDataType && !attachmentType) || (attachmentsCheckbox && !attachmentType) || (structuredDataCheckbox && !structuredDataType) || Number.parseFloat(fileSize) <= 0}
                                    submit={() => {
                                        downloadFile();
                                    }}
                                />
                            </div> :
                            <div>
                                <Button
                                    text="Dismiss"
                                    submit={() => close()}
                                    ghost
                                />
                                <span style={{ width: rem(10), display: 'inline-block' }}></span>
                                <Button
                                    text="Select Packages"
                                    submit={() => {
                                        close();
                                        goTo(`/package/folder/${downloadId}`, { isVeridaptFolder: isVeridapt });
                                    }}
                                />
                            </div>
                        }
                    </CardConfigure.Footer.Right>
                </CardConfigure.Footer>
            </CardConfigure>
        </Modal>
    );
}

DownloadAllDataModal.propTypes = {
    visible: PropTypes.bool,
    close: PropTypes.func,
    dataElementId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    messageStoreId: PropTypes.any,
    all: PropTypes.bool,
    isPackage: PropTypes.bool,
    isFolder: PropTypes.bool,
    isVeridapt: PropTypes.bool,
    defaultTotalFiles: PropTypes.number,
    downloadName: PropTypes.string,
    downloadId: PropTypes.any,
    packageActivity: PropTypes.string,
    defaultAttachmentType: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    defaultStructuredDataType: PropTypes.bool,
    defaultStructuredDataCheckbox: PropTypes.bool,
    defaultAttachmentsCheckbox: PropTypes.bool,
    defaultContainsTTFile: PropTypes.bool,
    defaultFileSize: PropTypes.string,
    isMultiPayload: PropTypes.any
}
